import { Places } from '../../Constants'
import { MainKeys } from '../../main/Main.keys'
import type { Perspectiva } from './Dashboards.perspectivas'

const DATA = /^\d{4}-\d{2}-\d{2}$/

export class DashboardsKeys extends MainKeys {
    public get place() {
        return Places.dashboards
    }

    /** Perspectiva aberta, para recarregar a página sem perdê-la. */
    public get aba(): Perspectiva | undefined {
        return (this._intent.getParameterAsString('aba') as Perspectiva) || undefined
    }

    public set aba(value: Perspectiva | undefined) {
        this._intent.setParameter('aba', value || null)
    }

    /** Só os negócios criados pela LIA, no dashboard de negócios. */
    public get origem(): 'todos' | 'lia' {
        return this._intent.getParameterAsString('origem') === 'lia' ? 'lia' : 'todos'
    }

    public set origem(value: 'todos' | 'lia') {
        this._intent.setParameter('origem', value === 'lia' ? 'lia' : null)
    }

    public get de(): string | undefined {
        const de = this._intent.getParameterAsString('de') ?? ''
        return DATA.test(de) ? de : undefined
    }

    public set de(value: string | undefined) {
        this._intent.setParameter('de', value || null)
    }

    public get ate(): string | undefined {
        const ate = this._intent.getParameterAsString('ate') ?? ''
        return DATA.test(ate) ? ate : undefined
    }

    public set ate(value: string | undefined) {
        this._intent.setParameter('ate', value || null)
    }
}

export default DashboardsKeys
